import {
  createActions
} from 'redux-actions';
import * as Types from './constants';

const { personas } = createActions({
  [Types.FIND_PERSONAS_ATTEMPT]: () => ({}),
  [Types.FIND_PERSONAS_SUCCESS]: (records, total) => ({ records, total }),
  [Types.FIND_PERSONAS_FAILURE]: (error) => ({ error }),
  [Types.UPSERT_PERSONA_ATTEMPT]: (values) => ({ values }),
  [Types.UPSERT_PERSONA_SUCCESS]: (persona) => ({ persona }),
  [Types.UPSERT_PERSONA_FAILURE]: (error) => ({ error }),
  [Types.CHANGE_PERSONA_FORM_VALUE]: (name, value) => ({ name, value }),
  [Types.RESET_PERSONA_FORM]: () => ({}),
  [Types.PERSONA_VALIDATION_ERROR]: (errors) => ({ errors }),
  [Types.TOGGLE_PERSONA_UPSERT_MODAL]: () => ({}),
  [Types.LOG_OUT]: () => ({})
});

export default personas;


// WEBPACK FOOTER //
// ./client/store/actions/personasActions.js